import Layout from '@/components/core/Layout';
import useHandleAuthError from '@/hooks/useHandleAuthError';

const ErrorBoundary = () => {
  const message = useHandleAuthError();

  return (
    <Layout>
      <p className="text-center m-5">{message}</p>
    </Layout>
  );
};

export default ErrorBoundary;
